module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./hu.coffee"));
	}, "locale/hu");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/hu.coffee
// module id = 275
// module chunks = 97